

import { useTheme } from "../ThemeContext";
import { useNavigate, useLocation } from 'react-router-dom'


function StyledLogo ({dark = 0, specialClass= ""}){

    const {colors,toggleTheme} = useTheme();

    // const [colors, setColors] = useState({});
    // const colorKeys= Object.keys(ColorsConst);

    const navigate = useNavigate();
    const { pathname } = useLocation();

    const switchColor =  (color, flag=1)=>{
        if(flag){
            return  dark ? color :color+'I';
        }
        else{
            return color+'I';
        }
    }

    // const findOppositeColor = (hexaColor)=>{
    //     let colorOposite = 0;
    //     let i = 0;

    //     while(!colorOposite && i<colorKeys.length){
    //         if (ColorsConst[colorKeys[i]]['light'] == hexaColor){
    //             colorOposite =ColorsConst[colorKeys[i]]['dark'];
    //         }
    //         else if (ColorsConst[colorKeys[i]]['dark'] == hexaColor){
    //             colorOposite =ColorsConst[colorKeys[i]]['light'];
    //         }
    //         i++;
    //     }

    //     return colorOposite;
    // }

    const handdleScroll  = (path)=>{
        if(pathname === path){
            window.scrollTo({top: 0, behavior: 'smooth'})
        }else{
            navigate('/');
        }
    }


    return(
        <svg onClick={()=>{handdleScroll(`/`)}}
            // height="256px" width="256px"
            version="1.1" viewBox="0 0 512 512" fill="#000000" className={`${specialClass} ${colors[switchColor('bgColor')] ? "" : "hided"}`}>
            <g id="SVGRepo_bgCarrier" strokeWidth="0"/>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
            <g id="SVGRepo_iconCarrier"> <g> <g> <path style={{fill:colors[switchColor('bgColor')]}} d="M343.736,404.417c0,31.472-25.509,56.984-56.981,56.984h-61.511 c-31.465,0-56.981-25.512-56.981-56.984l0,0c0-31.472,25.516-56.984,56.981-56.984h61.511 C318.227,347.433,343.736,372.945,343.736,404.417L343.736,404.417z"/> <path style={{fill:colors[switchColor('bgColor')]}} d="M300.341,72.46c0,0,43.416-54.272,54.276-65.126C365.47-3.52,384.46-3.52,389.89,15.472 c5.423,18.996,37.992,116.687,37.992,116.687L512,320.295h-45.516v45.227l-38.898-8.142l-13.566,38.895l-36.179-16.281 l-18.09,34.374l-58.898-33.924l-47.834,23.07h5.963l-47.835-23.07l-58.898,33.924l-18.09-34.374l-36.18,16.281L84.414,357.38 l-38.898,8.142v-45.227H0l84.118-188.136c0,0,32.568-97.691,37.992-116.687c5.43-18.992,24.426-18.992,35.28-8.138 c10.853,10.853,54.269,65.126,54.269,65.126H300.341z"/> <g> <g><polygon style={{fill:colors[switchColor('deepBlue')]}} points="182.728,100.5 147.455,54.37 133.89,100.5 "/> </g> <g> <polygon style={{fill: colors[switchColor('deepBlue')]}} points="329.272,100.5 364.544,54.37 378.11,100.5 "/> </g> </g> <path style={{fill: colors[switchColor('deepBlue')]}} d="M256,403.514h32.562c0,0,27.328,1.084,48.307-19.898c25.326-25.326,35.135-78.019,35.135-78.019 c22.384-3.391,64.322-66.567,18.313-108.314c-48.839-44.321-127.534,3.165-118.486,79.145v74.584l14.38,39.84L256,394.469v1.806 l-30.217-3.615l14.386-39.84v-74.585c9.041-75.983-69.647-123.469-118.492-79.145c-46.002,41.747-4.071,104.924,18.313,108.315 c0,0,9.816,52.69,35.135,78.015c20.985,20.985,48.307,19.899,48.307,19.899H256V403.514z"/> <g> <g> <path style={{fill:colors[switchColor('emeraldGreen', 0)], cursor:'pointer'}} onClick={toggleTheme} d="M180.614,252.88h-18.609l6.021,8.162c-0.781,1.733-1.228,3.628-1.228,5.636 c0,7.63,6.178,13.819,13.815,13.819c7.617,0,13.802-6.189,13.802-13.819C194.416,259.062,188.231,252.88,180.614,252.88z"/> </g> <g> <path style={{fill:colors[switchColor('emeraldGreen', 0)], cursor:'pointer'}} onClick={toggleTheme} d="M331.386,252.88h18.609l-6.014,8.162c0.775,1.733,1.221,3.628,1.221,5.636 c0,7.63-6.179,13.819-13.815,13.819c-7.617,0-13.802-6.189-13.802-13.819C317.584,259.062,323.769,252.88,331.386,252.88z"/> </g> </g> <path style={{fill:colors[switchColor('intenseViolet')]}} d="M283.046,383.839c-5.759,0-27.046,0-27.046,0s-21.294,0-27.046,0 c-16.113,0-26.461,19.56-13.802,35.673c15.779,20.092,30.487,20.713,40.848,20.713c10.354,0,25.063-0.621,40.848-20.713 C309.514,403.399,299.159,383.839,283.046,383.839z"/> </g> <path style={{fill:colors[switchColor('intenseViolet')], opacity:0.23}} d="M427.882,132.159c0,0-32.568-97.691-37.992-116.687 C384.46-3.52,365.47-3.52,354.617,7.334c-10.86,10.853-54.276,65.126-54.276,65.126h-49.659v388.941h36.074 c31.228,0,56.561-25.135,56.948-56.275l16.048,9.242l18.09-34.374l36.179,16.281l13.566-38.895l38.898,8.142v-45.227H512 L427.882,132.159z"/></g> </g>
        </svg>
    )
}
export default StyledLogo;